import script from "./ReviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewModal.vue?vue&type=script&setup=true&lang=js"

import "./ReviewModal.vue?vue&type=style&index=0&id=73884bc0&scoped=true&lang=css"
/* custom blocks */
import block0 from "./ReviewModal.vue?vue&type=custom&index=0&blockType=spec&lang=md"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73884bc0"]])

export default __exports__